import { themes } from '../MatxTheme/initThemes'
import { Theme } from '../MatxTheme/themes'

export const themeVariants = [
  {
    // Hall is the platform's own default tenant: it's what local dev and any
    // unmatched/unbranded host fall back to.
    rule: /localhost|127.0.0.1/i,
    theme: Theme.HALL,
  },
  {
    rule: /(.*).hall.app.br|hall-hml.concordia.dev.br|hall-dev.concordia.dev.br/i,
    theme: Theme.HALL,
  },
  {
    rule: /(.*).amsm.com.br|(.*)amsm-hml.concordia.dev.br|amsm-dev.concordia.dev.br|lucas-torresans-macbook-air.local/i,
    theme: Theme.AMSM,
  },
  {
    rule: /(.*).actiontreinamento.com.br|(.*)action-hml.concordia.dev.br|action-dev.concordia.dev.br/i,
    theme: Theme.ACTION,
  },
  {
    rule: /(.*).guilhermelazaretti.com.br/i,
    theme: Theme.GUILHERMELAZARETTI,
  },
  {
    rule: /(.*).gilbertopelissari.com.br/i,
    theme: Theme.GIBA,
  },
  {
    rule: /(.*)cic.concordia.dev.br|(.*).cicsm.com.br/i,
    theme: Theme.CIC,
  },
  {
    rule: /(.*)clab.concordia.dev.br/i,
    theme: Theme.CLAB,
  },
  // {
  //   rule: /(.*)igorsandi.concordia.dev.br|(.*).igorsandi.com.br/i,
  //   theme: 'igorsandi',
  // },
  // {
  //   rule: /(.*)bioacademia.concordia.dev.br/i,
  //   theme: 'bioacademia',
  // },
  // {
  //   rule: /(.*)dcfit.concordia.dev.br/i,
  //   theme: 'dcfit',
  // },
  // {
  //   rule: /(.*)larissacioato.concordia.dev.br/i,
  //   theme: 'larissacioato',
  // },
  {
    rule: /(.*)afa.hall.app.br/i,
    theme: Theme.AFA,
  },
  {
    rule: /(.*)exos.hall.app.br/i,
    theme: Theme.EXOS,
  },
  {
    rule: /(.*)ofragozo.hall.app.br/i,
    theme: Theme.OFRAGOZO,
  },
  {
    rule: /(.*)rena.hall.app.br/i,
    theme: Theme.RENA,
  },
  {
    rule: /(.*)thestudio.hall.app.br/i,
    theme: Theme.THESTUDIO,
  },
  {
    rule: /(.*)pem.hall.app.br/i,
    theme: Theme.PEM,
  },
]

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const MatxLayoutSettings = {
  activeLayout: 'layout1', // layout1, layout2
  activeTheme: null, // View all valid theme colors inside MatxTheme/themeColors.js
  perfectScrollbar: false,

  themes: themes,
  layoutSettings: {
    leftSidebar: {
      show: true,
      mode: 'full', // full, close, compact, mobile,
      bgImgURL: '/assets/images/sidebar/sidebar-bg-dark.jpg', // TODO: Change image
    },
    topbar: {
      show: true,
      fixed: true,
      theme: 'topbar', // View all valid theme colors inside MatxTheme/themeColors.js
    },
  },
}
